module.exports = __webpack_public_path__ + "static/media/e-comienzo.37d89428.svg";